import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL;
const MONTSERRAT = { fontFamily: '"Geist Variable", "Helvetica Neue", Arial, sans-serif' };
const FIELD = "font-doc block w-full border border-white/20 bg-black/50 px-4 py-3 text-base leading-relaxed text-white/90 placeholder:text-white/35 outline-none transition-[border-color,box-shadow] duration-500 focus:border-[#84DFF4]/60 focus:shadow-[0_0_0_1px_rgba(132,223,244,0.25),0_0_24px_rgba(132,223,244,0.12)] sm:text-lg";

export const InvitationForm = () => {
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!message.trim() || !email.trim() || state === "sending") return;
    setState("sending");
    try {
      await axios.post(`${API}/api/invitation/messages`, { message: message.trim(), email: email.trim() });
      setState("sent");
      setMessage("");
      setEmail("");
    } catch (err) {
      setState("idle");
      toast.error(err.response?.data?.detail || "That didn't go through. Try once more.");
    }
  };

  if (state === "sent") {
    return (
      <div data-testid="invitation-form-sent" className="flex flex-col items-center gap-4 py-2 text-center">
        <span aria-hidden="true" className="block h-px w-[50px] bg-[#8E8E93]/40" />
        <p style={MONTSERRAT} className="text-xs font-light uppercase tracking-[0.3em] text-[#8E8E93]/85">Message sent</p>
        <p className="font-doc text-base italic leading-relaxed text-white/60 sm:text-lg">It has reached the studio. A copy is on its way to your inbox; Charlie and Dominic read every reply themselves.</p>
      </div>
    );
  }

  return (
    <form data-testid="invitation-form" onSubmit={submit} className="flex w-full flex-col gap-4">
      <label className="block">
        <span className="sr-only">Your email</span>
        <input data-testid="invitation-form-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required maxLength={200} autoComplete="email" inputMode="email"
          placeholder="Your email" className={FIELD} />
      </label>
      <div className="flex w-full flex-col gap-4 sm:flex-row sm:items-end">
      <label className="flex-1">
        <span className="sr-only">Your message</span>
        <textarea data-testid="invitation-form-message" value={message} onChange={(e) => setMessage(e.target.value)} required rows={2} maxLength={4000}
          placeholder="Your message." className={`${FIELD} resize-none`} />
      </label>
      <button type="submit" data-testid="invitation-form-submit" data-cursor disabled={state === "sending"} style={MONTSERRAT}
        className="group inline-flex min-h-[48px] items-center justify-center gap-2 border border-[#84DFF4]/50 px-7 py-3 text-xs font-light uppercase tracking-[0.3em] text-[#84DFF4] transition-[border-color,color,background-color,letter-spacing] duration-500 hover:border-[#84DFF4] hover:bg-[#84DFF4]/[0.06] hover:tracking-[0.36em] hover:text-[#E8CC6B] disabled:opacity-50">
        {state === "sending" ? "Sending" : "Send"}
      </button>
      </div>
    </form>
  );
};
